module.exports = __webpack_public_path__ + "img/212w.b92db82.jpg";